import dayjs from 'dayjs/esm';
import { ICbicContentTypeMst } from 'app/entities/cbic-content-type-mst/cbic-content-type-mst.model';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';

export interface ICbicDocMst {
  id?: number;
  isActive?: string | null;
  orderId?: number | null;
  createdDt?: dayjs.Dayjs | null;
  updatedDt?: dayjs.Dayjs | null;
  createdBy?: number | null;
  updateBy?: number | null;
  versionNo?: number | null;
  isPublished?: string | null;
  publishDt?: dayjs.Dayjs | null;
  isArchived?: string | null;
  archiveDt?: dayjs.Dayjs | null;
  parentId?: number | null;
  taxId?: number | null;
  locationId?: number | null;
  docType?: string | null;
  docNo?: string | null;
  docTitleEn?: string | null;
  docTitleHi?: string | null;
  fileType?: string | null;
  fileNameEn?: string | null;
  fileNameHi?: string | null;
  filePathEn?: string | null;
  filePathHi?: string | null;
  image?: string | null;
  documentDt?: dayjs.Dayjs | null;
  refDt1?: dayjs.Dayjs | null;
  refDt2?: dayjs.Dayjs | null;
  expiryDt?: dayjs.Dayjs | null;
  year?: number | null;
  contentType?: ICbicContentTypeMst | null;
  content?: ICbicContentMst | null;
}

export class CbicDocMst implements ICbicDocMst {
  constructor(
    public id?: number,
    public isActive?: string | null,
    public orderId?: number | null,
    public createdDt?: dayjs.Dayjs | null,
    public updatedDt?: dayjs.Dayjs | null,
    public createdBy?: number | null,
    public updateBy?: number | null,
    public versionNo?: number | null,
    public isPublished?: string | null,
    public publishDt?: dayjs.Dayjs | null,
    public isArchived?: string | null,
    public archiveDt?: dayjs.Dayjs | null,
    public parentId?: number | null,
    public taxId?: number | null,
    public locationId?: number | null,
    public docType?: string | null,
    public docNo?: string | null,
    public docTitleEn?: string | null,
    public docTitleHi?: string | null,
    public fileType?: string | null,
    public fileNameEn?: string | null,
    public fileNameHi?: string | null,
    public filePathEn?: string | null,
    public filePathHi?: string | null,
    public image?: string | null,
    public documentDt?: dayjs.Dayjs | null,
    public refDt1?: dayjs.Dayjs | null,
    public refDt2?: dayjs.Dayjs | null,
    public expiryDt?: dayjs.Dayjs | null,
    public year?: number | null,
    public contentType?: ICbicContentTypeMst | null,
    public content?: ICbicContentMst | null
  ) {}
}

export function getCbicDocMstIdentifier(cbicDocMst: ICbicDocMst): number | undefined {
  return cbicDocMst.id;
}
